{
	"labels": {
		"naziv":"Naziv",
		"naslov":"Naslov",
		"posta":"Pošta",
		"kraj":"Kraj",
		"telefon":"Telefon",
		"email":"Email"
	},
	"buttons": {
		"vnesi": "Vnesi zapis"
	}
}